import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-444a0d90"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "box form" }
const _hoisted_2 = { class: "columns" }
const _hoisted_3 = {
  class: "column is-5",
  role: "form",
  "aria-label": "Formulário para criação de uma nova tarefa"
}
const _hoisted_4 = { class: "column is-3" }
const _hoisted_5 = { class: "select" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, "Selecione o projeto", -1))
const _hoisted_7 = ["value"]
const _hoisted_8 = { class: "column" }
const _hoisted_9 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TimerComponent = _resolveComponent("TimerComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _withDirectives(_createElementVNode("input", {
          type: "text",
          class: "input",
          placeholder: "Qual tarefa você deseja iniciar?",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.description) = $event))
        }, null, 512), [
          [_vModelText, _ctx.description]
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.projectId) = $event))
          }, [
            _hoisted_6,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.projects, (project) => {
              return (_openBlock(), _createElementBlock("option", {
                value: project.id,
                key: project.id
              }, _toDisplayString(project.name), 9, _hoisted_7))
            }), 128))
          ], 512), [
            [_vModelSelect, _ctx.projectId]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        (_ctx.projectId)
          ? (_openBlock(), _createBlock(_component_TimerComponent, {
              key: 0,
              onOnTimerOff: _ctx.endTask
            }, null, 8, ["onOnTimerOff"]))
          : (_openBlock(), _createElementBlock("p", _hoisted_9, "Crie ou selecione um projeto para começar."))
      ])
    ])
  ]))
}